import { Injectable, inject } from '@angular/core';
import { HttpService } from '@shared/services';
import { AddCommentApprovalModel, DoApprovalModel } from './awaiting-approval.model';

@Injectable({ providedIn: 'root' })
export class AwaitingApprovalService {
  http = inject(HttpService);

  addApprovalComment(body: AddCommentApprovalModel, contractId: number) {
    const params = this.http.buildHttpParams({ contractId });
    return this.http.put<number>('_api/ModuleInstanceApproval/AddComment', body, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  cancelApprovel(approvalId: number, contractId: number) {
    const params = this.http.buildHttpParams({ approvalId, contractId });
    return this.http.put<number>('_api/ModuleInstanceApproval/CancelApproval', null, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  doApproval(body: DoApprovalModel, contractId: number, roleId?: number) {
    const params = this.http.buildHttpParams({ contractId, roleId });
    return this.http.put<number>('_api/ModuleInstanceApproval/DoApproval', body, {
      useLoader: false,
      httpOptions: { params },
    });
  }
}
